import { render, staticRenderFns } from "./stepHome.vue?vue&type=template&id=745b8f96&"
import script from "./stepHome.vue?vue&type=script&lang=js&"
export * from "./stepHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports